exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mergeStudentListsForm .slList{height:35em;overflow:scroll}.mergeStudentListsForm .slList .btnContainer{text-align:center;margin-top:1em}.mergeStudentListsForm .slList .btnContainer .submitLink{width:10em}.mergeStudentListsForm .slRow{width:100%;display:inline-block;padding:.3em 0}.mergeStudentListsForm .slRow.borderBottom{border-bottom:1px solid #eee}.mergeStudentListsForm .slRow .slColumn{width:50%;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1em}.mergeStudentListsForm .slRow .slOptionsColumn{width:45%;display:inline-block;vertical-align:top}.mergeStudentListsForm .slRow .slOptionsColumn .btn-group{width:100%}.mergeStudentListsForm .slRow .slOptionsColumn .btn-group .dropdown-toggle{width:100%;white-space:nowrap;overflow:scroll;text-overflow:ellipsis}.mergeStudentListsForm .labelRow{width:100%;font-size:1.2em;border-bottom:1px solid #ddd}.mergeStudentListsForm .labelRow .studentListListLabel{width:50%;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/shared/merge_student_lists_form.scss
// module id = 1393
// module chunks = 0